import { ReactRouterAppProvider } from '@toolpad/core/react-router';
import * as React from 'react';
import { AUTHENTICATION, getBranding, NAVIGATION } from './layouts/AppConfig';
import AppContent, { useAppSession } from './layouts/AppContent';

export default function App() {
  const sessionContextValue = useAppSession();
  const isStaff = sessionContextValue.session?.accountType === 'Staff';
  const branding = React.useMemo(() => {
    return getBranding();
  }, []);

  return (
    <ReactRouterAppProvider
      navigation={isStaff ? NAVIGATION : []}
      branding={branding}
      session={sessionContextValue.session}
      authentication={AUTHENTICATION}
    >
      <AppContent />
    </ReactRouterAppProvider>
  );
}
